<template>
<div class="chapter">
<div class="inner_page">
<p> </p>
<p class="fronthead"><a id="page_ix"></a>ACKNOWLEDGMENTS</p>
<p> </p>
<p> </p>
<p class="body-text">Two portions of this book have been previously published and appear here by permission of the publishers. A version of <span href="#/18_chapter06" title="Link target outside of Sample">chapter 6</span> appeared in <i>Representations</i> 18 (1987): 129–57 (copyright by the Regents of the University of California). A version of <span href="#/19_chapter07" title="Link target outside of Sample">chapter 7</span> appeared in <i>Studies in the Literary Imagination</i> (1993): 85–113 (copyright by the Department of English, Georgia State University). Early stages of my research were made possible by fellowships from the American Council of Learned Societies and the John Simon Guggenheim Memorial Foundation.</p>
<p class="indent">In the course of researching, writing, and composing this book, I have become indebted to many colleagues and friends, who read parts originally presented as conference papers and also drafts of chapters that were shaped with the benefit of their thoughtful questions and advice. For all their help, I want to thank Janet Adelman, Paul Alpers, Bradin Cormack, Richard Feingold, Stephen Greenblatt, Lorna Hutson, Victoria Kahn, Jeffrey Knapp, Peter Platt, Norman Rabkin, and especially Thomas Sloane, whose historical insight, rhetorical mastery, and generous friendship were resources I drew upon again and again. I also wish to thank my editor, Alan Thomas, for so astutely shepherding the manuscript to publication. I am most grateful to my family, for their patient skepticism and unflagging faith over the years, and to my dear Sandra, for her exemplary moral courage and loving support.<a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_acknowledgement.vue?c4fffa94